import React from 'react';
import { TabState } from '../../types';
import { TabRegistry } from './TabRegistry';
import logger from '../utils/logger';

/**
 * TabContentRenderer
 * 
 * TabRegistryを使用してタブコンテンツをレンダリングする
 * 各タブコンポーネントは自身で必要なデータをContextから取得する
 */

interface TabContentRendererProps {
  tab: TabState;
  containerId: string;
}

export const TabContentRenderer: React.FC<TabContentRendererProps> = ({ tab }) => {
  const registryEntry = TabRegistry[tab.type];
  
  if (!registryEntry) {
    logger.error('Unknown tab type:', tab.type);
    return <div>Unknown tab type: {tab.type}</div>;
  }
  
  const Component = registryEntry.component;
  
  // タブコンポーネントに渡すpropsは最小限に
  return <Component tab={tab} />;
};

// メモ化してパフォーマンスを最適化
export default React.memo(TabContentRenderer);